import { EngineOptions } from './types';
import { Suggestion } from './slice/types';
import { stripHtml } from './slice/utils';

import bingIcon from './assets/engines/bing.svg';
import ddgIcon from './assets/engines/ddg.webp';
import ecosiaIcon from './assets/engines/ecosia.webp';
import googleIcon from './assets/engines/google.svg';
import ohIcon from './assets/engines/oh.webp';
import wikipediaIcon from './assets/engines/wikipedia.svg';
import yahooIcon from './assets/engines/yahoo.svg';
import youtubeIcon from './assets/engines/youtube.svg';

export const engineIcons = {
  bing: bingIcon,
  duckDuckGo: ddgIcon,
  ecosia: ecosiaIcon,
  google: googleIcon,
  oh: ohIcon,
  wikipedia: wikipediaIcon,
  yahoo: yahooIcon,
  youtube: youtubeIcon,
};

const defaultFormatter = async (res: Response): Promise<string[]> => {
  const [, data] = await res.json();
  return data;
};

// export const PRIMARY_ENGINES =
//   ['oh', 'bing', 'google', 'yahoo', 'duckDuckGo', 'ecosia', 'google'];

export const ENGINES: Record<string, EngineOptions> = {
  oh: {
    v: 'OceanHero',
    url: `${process.env.APP_URL || 'https://oceanhero.today'}/web`,
    q: 'q',

    suggestionsUrl: 'https://api.oceanhero.today/suggestions',
    query: (q, searchTag) => (searchTag ? { q, searchTag: searchTag.s } : { q }),
    formatter: defaultFormatter,
  },
  bing: {
    v: 'Microsoft Bing',
    url: 'https://www.bing.com/search',
    q: 'q',

    suggestionsUrl: 'https://api.oceanhero.today/suggestions',
    query: (q) => ({ q }),
    formatter: defaultFormatter,
  },

  // wikipedia: {
  //   v: 'Wikipedia',
  //   q: 'search',
  //   url: 'https://en.wikipedia.org/wiki/Special:Search',
  //   suggestionsUrl: 'https://en.wikipedia.org/w/api.php',
  //   query: (q) => ({
  //     action: 'query',
  //     gsrsearch: q,
  //     format: 'json',
  //     generator: 'search',
  //     origin: '*',
  //   }),
  // },

  yahoo: {
    v: 'Yahoo',
    url: 'https://search.yahoo.com/search',
    // suggestionsUrl: 'https://sugg.search.yahoo.net/sg/',

    suggestionsUrl: 'https://api.oceanhero.today/suggestions',
    q: 'q',
    query: (q) => ({ q }),
    formatter: async (res: Response): Promise<string[]> => {
      const { gossip: { results: results } } = await res.json();
      return results.map(({ key }) => key);
    }
  },
  duckDuckGo: {
    v: 'DuckDuckGo',
    url: 'https://duckduckgo.com',
    suggestionsUrl: 'https://duckduckgo.com/ac/',
    q: 'q',
    query: (q): Record<string, string> => ({ q }),
    formatter: async (res: Response) => {
      const data = await res.json();
      return data.map(({ phrase }) => phrase);
    }
  },
  ecosia: {
    v: 'Ecosia',
    url: 'https://www.ecosia.org/search',
    suggestionsUrl: 'https://ac.ecosia.org/autocomplete',
    q: 'q',
    query: (q) => ({ q }),
    formatter: async (res: Response) => {
      const { suggestions } = await res.json();
      return suggestions;
    }
  },
  google: {
    v: 'Google',
    url: 'https://www.google.com/search',
    suggestionsUrl : 'https://www.google.com/complete/search',
    q: 'q',
    query: (q) => ({ cp: '5', client: 'gws-wiz', xssi: 't', dpr: '2', q }),
    formatter: async (res): Promise<Suggestion[]> => {
      try {
        const response = await res.text();
        const [json] = JSON.parse(response.replace(`)]}'`, ''));
        return json.map((data) => {
          const props = data[3] || {};
          if (props.du) return null;
          return {
            term: stripHtml(props.zh || data[0]),
            favIconUrl: props.zs,
            query: props.zp,
            label: props.zi,
          }
        }).filter(Boolean);
      } catch (err) {
        return [];
      }
    }
  },
  // youtube: {
  //   v: 'Youtube',
  //   q: 'search_query',
  //   url: 'https://www.youtube.com/results',
  //   // suggestionsUrl: 'http://suggestqueries.google.com/complete/search',
  //   suggestionsUrl,
  // if (['google', 'youtube'].includes(engine)) {
  //   return new URLSearchParams({
  //     q,
  //     client: 'chrome',
  //     ds: engine === 'youtube' ? 'yt' : ''
  //   });
  // }
  // },
};
